<template>
  <div>
    <form-wizard @on-complete="onComplete" shape="square" color="#1e3d73" class="bg-white">
      <tab-content title="Personal details" icon="far fa-user">
        <vs-row vs-w="12" class="mb-3">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="mb-4">
            <vs-input
              :success="fnamesuccess"
              success-text="First Name is valid."
              :danger="fnamedanger"
              danger-text="First Name is required."
              label="Email address"
              class="w-full"
              v-model="fname"
              name="input1"
            />
            <small>You will occasionally receive account related emails.</small>
          </vs-col>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-input
              :success="lnamesuccess"
              success-text="Last Name is valid."
              :danger="lnamedanger"
              danger-text="Last Name is required."
              label="Username"
              class="w-full"
              v-model="lname"
            />
            <small>Only letters, numbers, and underscores are allowed.</small>
          </vs-col>
        </vs-row>
      </tab-content>
      <tab-content title="Additional Info" icon="fas fa-key">
        <vs-row vs-w="12" class="mb-3">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-input
              :success="addresssuccess"
              success-text="Address is valid."
              :danger="addressdanger"
              danger-text="Address is required."
              label="Address"
              class="w-full"
              v-model="address"
              placeholder="1234 Main St"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="mb-3">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-input
              :success="address2success"
              success-text="Address 2 is valid."
              :danger="address2danger"
              danger-text="Address 2 is required."
              label="Address 2"
              class="w-full"
              v-model="address2"
              placeholder="Appartment, Studio"
            />
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="mb-3">
          <vs-col vs-lg="5" vs-sm="6" vs-xs="12">
            <vs-input
              :success="citysuccess"
              success-text="City is valid."
              :danger="citydanger"
              danger-text="City is required."
              label="City"
              class="w-full"
              v-model="city"
              placeholder="City"
            />
          </vs-col>
          <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
            <vs-select
              v-model="select1"
              :success="statessuccess"
              success-text="State is valid."
              :danger="statesdanger"
              danger-text="State is required."
              class="w-full"
              label="State"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in states"
                class="w-full"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
            <vs-input
              :success="zipsuccess"
              success-text="Zip is valid."
              :danger="zipdanger"
              danger-text="Zip is required."
              label="Zip"
              v-model="zip"
              class="w-full"
              placeholder="Zip"
            />
          </vs-col>
        </vs-row>
      </tab-content>
      <tab-content title="Last step" icon="fab fa-cc-stripe">
        <div class="form p-5 text-center">
          <h3>Thank you !</h3>
          <p>
            Quisque nec turpis at urna dictum luctus. Suspendisse convallis
            dignissim eros at volutpat. In egestas mattis dui. Aliquam mattis
            dictum aliquet.
          </p>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
export default {
  components: {
    FormWizard,
    TabContent,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
    validationForm() {},
    onComplete: function () {
      alert("Yay. Done!");
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      fname: "",
      select1: "",
      fnamesuccess: false,
      fnamedanger: false,
      lname: "",
      lnamesuccess: false,
      lnamedanger: false,
      address: "",
      addresssuccess: false,
      addressdanger: false,
      address2: "",
      address2success: false,
      address2danger: false,
      city: "",
      citysuccess: false,
      citydanger: false,
      state: "",
      statesuccess: false,
      statedanger: false,
      zip: "",
      zipsuccess: false,
      zipdanger: false,
      states: [
        { text: "New York", value: "new-york" },
        { text: "New York", value: "new-york" },
        { text: "New York", value: "new-york" },
      ],
      statessuccess: false,
      statesdanger: false,
    };
  },
};
</script>